import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';

const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/"; //pasar id del estudiante
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login

class SidebarRectorado extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (
            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Rectorado</p>
                        </div>

                        <Link to="/rectorado" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal
                        </Link>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfil"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>Perfil
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePerfil">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/rectorado/VerPerfilRectorado" className="nav-sub-link">
                                        Ver Perfil
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseMatriculas"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>Matrículas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseMatriculas">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/rectorado/cantidadmatri" className="nav-sub-link">
                                        Cantidad de matriculados
                                    </Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario: <br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}
export default withRouter(SidebarRectorado);
